import { useState, useEffect } from 'react';

export type ConnectionQuality = 'fast' | 'slow' | 'offline';

export const useConnectionQuality = () => {
  const [quality, setQuality] = useState<ConnectionQuality>('fast');

  useEffect(() => {
    // Check if Network Information API is available
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      
      const updateQuality = () => {
        if (!connection) return;
        
        // Detect slow connections
        if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
          setQuality('slow');
        } else if (connection.effectiveType === '3g' && connection.downlink < 1.5) {
          setQuality('slow');
        } else {
          setQuality('fast');
        }
      };

      updateQuality();
      connection.addEventListener('change', updateQuality);
      
      return () => {
        connection.removeEventListener('change', updateQuality);
      };
    }

    // Fallback: Test download speed with a small image
    const testSpeed = async () => {
      try {
        const startTime = Date.now();
        const response = await fetch('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', {
          cache: 'no-cache'
        });
        await response.blob();
        const duration = Date.now() - startTime;
        
        // If it takes more than 100ms for a tiny image, probably slow connection
        setQuality(duration > 100 ? 'slow' : 'fast');
      } catch {
        setQuality('slow');
      }
    };

    testSpeed();
  }, []);

  return quality;
};